import cn from 'classnames'

import styles from './styles.module.scss'
interface CustomButtonProps {
    onClick?: () => void
    textBtn: string
    classNames?: {
        textBtn?: string
    }
    disabled?: boolean
}
export const CustomButton = ({
    onClick,
    textBtn,
    classNames,
}: CustomButtonProps) => {
    return (
        <button className={styles.button} onClick={onClick}>
            <span className={cn(styles.text, classNames?.textBtn)}>
                {textBtn}
            </span>
        </button>
    )
}
